module.exports = __webpack_public_path__ + "static/media/tire-skid.8867552e.svg";